import { requestMain, requestFreemium } from './index'

export const getPushNotif = () => {
  return requestMain({
    url: 'setting-notification',
    method: 'get'
  })
}

export const updatePushNotif = payload => {
  return requestMain({
    url: 'setting-notification',
    method: 'POST',
    data: payload.body
  })
}

export const getPushNotifFree = () => {
  return requestFreemium({
    url: 'setting-notification',
    method: 'get'
  })
}

export const updatePushNotifFree = (payload) => {
  return requestFreemium({
    url: 'setting-notification',
    method: 'POST',
    data: payload.body
  })
}

const PushNotification = {
  getPushNotif,
  updatePushNotif,
  getPushNotifFree,
  updatePushNotifFree
}

export default PushNotification
